module.exports = __webpack_public_path__ + "static/media/Headstorm_logo.1d84400f.svg";